export const shortenNumber = (number) => {
    if (isNaN(number)) {
        return number;
    }

    if (number < 1000000) {
        return Intl.NumberFormat('en-US').format(number);
    }

    return Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short" }).format(number);
}

export const shortenFloat = (float) => {
    if (isNaN(float) || !isFinite(float)) {
        return 0;
    }

    return Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short", maximumSignificantDigits: 3 }).format(float);
}

export const humanFileSize = (bytes, si=false, dp=1) => {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes.toFixed(dp) + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }